import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

import './PasswordFormControl.scss';
import PasswordHint, { passwordHintWrapperClassName } from './PasswordHint';

import eyeSlash from 'assets/icons/eye-slash.svg';
import eye from 'assets/icons/eye.svg';

type PasswordFormControlProps = {
    withHint?: boolean;
    [x: string]: any;
};

const PasswordFormControl = (props: PasswordFormControlProps) => {
    const { value: propsValue = '', onChange = () => {}, inputClassName, className, withHint = false, ...rest } = props;

    const [type, setType] = useState<'password' | 'text'>('password');
    const [value, setValue] = useState(props.value ?? ``);

    useEffect(() => {
        setValue(propsValue);
    }, [propsValue]);

    return (
        <div className={clsx('container', passwordHintWrapperClassName, className)}>
            <Form.Control
                {...rest}
                className={clsx('input', inputClassName)}
                type={type}
                value={value ?? ``}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setValue(e.target.value);
                    onChange(e);
                }}
            />
            <img
                onClick={() => {
                    setType(type === 'password' ? 'text' : 'password');
                }}
                className={'eye'}
                src={type === 'password' ? eye : eyeSlash}
                alt="Eye"
            />
            {withHint && <PasswordHint value={value} />}
        </div>
    );
};

export default PasswordFormControl;
